<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";
import type { MenuItem } from "primevue/menuitem";

import { isSidebarLinkActive } from "@/composables/sidebar-nav-active";

const props = defineProps<{ item: MenuItem }>();

const route = useRoute();

const isGroupActive = computed(() => {
  const children = props.item.items?.filter((c) => c.visible !== false && c.route) ?? [];
  return children.some((c) => isSidebarLinkActive(route.path, c.route!));
});

const rowClass = computed(() => [
  "box-border flex min-h-11 w-full min-w-0 cursor-pointer select-none items-center gap-2.5 border-b-[0.5px] border-l-[3px] border-solid border-b-base-content/[0.07] border-l-transparent px-2 py-2.5 text-left text-base font-medium text-base-content transition-colors duration-150 hover:bg-base-200/50 dark:hover:bg-base-200/20 touch-manipulation",
  isGroupActive.value ? "border-l-primary bg-primary/10 font-semibold text-primary" : "",
]);
</script>

<template>
  <div :class="rowClass">
    <template v-if="props.item.image">
      <img :src="props.item.image" class="size-5 shrink-0 rounded" alt="" />
    </template>
    <template v-else-if="props.item.icon">
      <i
        :class="[
          'shrink-0 p-menu-item-icon pi',
          props.item.icon,
          isGroupActive ? 'text-primary' : 'text-primary/80',
        ]"
      />
    </template>
    <div class="min-w-0 truncate leading-snug">{{ props.item.label }}</div>
    <span v-if="props.item.items?.length" class="pi pi-angle-down ml-auto shrink-0 text-primary" />
  </div>
</template>
